'use strict';

angular.module('app.duplicationFactors', [])
    .controller('duplicationFactorsCtrl', ['$scope', '$modal', 'duplicationFactorsService',
        function ($scope, $modal, duplicationFactorsService) {
            
            var month = new Date().getMonth() + 1;
            var year = new Date().getFullYear();
            $scope.period = [
                {label: 'Jan ', month: 1},
                {label: 'Feb ', month: 2},
                {label: 'Mar ', month: 3},
                {label: 'Apr ', month: 4},
                {label: 'May ', month: 5},
                {label: 'Jun ', month: 6},
                {label: 'Jul ', month: 7},
                {label: 'Aug ', month: 8},
                {label: 'Sep ', month: 9},
                {label: 'Oct ', month: 10},
                {label: 'Nov ', month: 11},
                {label: 'Dec ', month: 12}
            ];
            
            $scope.currentPeriod = "" + year + "-" + month;

            $scope.changePeriod = function (params) {
                loadData(params);
            }

            function loadData(params) {
                var params = {
                    month: params
                }

                $scope.duplicationFactors = [];
                duplicationFactorsService.getDuplicationFactors(params, true)
                    .then(function(response) {
                        angular.forEach(response.data, function(item) {
                            item.value = item.value.toFixed(3);
                            $scope.duplicationFactors.push(item);
                            $scope.currentPeriod = item.month;
                        })
                        var currentDate = $scope.currentPeriod.split("-");
                        angular.forEach($scope.period, function (item) {
                            if (parseInt(currentDate[1]) === item.month && item.label.indexOf(currentDate[0]) < 0) {
                                item.label = item.label.split(" ")[0];
                                item.label = item.label + " " + currentDate[0];
                                item.ticked = true;
                            }
                        })
                    }, function(response) {
                        var errorModalInstance = $modal.open({
                            scope: $scope,
                            templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                            windowClass: 'modal-dialog-mention-error'
                        });
                        $scope.errorModalInstance = errorModalInstance;
                        $scope.errorMessage = response.message;
                    })
            }

            loadData($scope.currentPeriod);

            $scope.updateDuplicationFactors = function(){
                var updateDuplicationFactorsModalInstance = $modal.open({
                    scope: $scope,
                    templateUrl: 'app/admin/duplicationFactors/updateDuplicationFactors/updateDuplicationFactors.html?app_v=deployDate',
                    controller: 'updateDuplicationFactorsCtrl'
                });

                $scope.updateDuplicationFactorsModalInstance = updateDuplicationFactorsModalInstance;
            }

            $scope.resetDuplicationFactors = function(){
                loadData($scope.currentPeriod);
            }
}])
